import { Skeleton } from "@tellescope/ui";
import { MessagesSkeleton } from "../../../components/chat";

export const PageSkeleton = () => (
  <div className="min-h-screen bg-background flex flex-col">
    <div className="border-b bg-background">
      <div className="container mx-auto max-w-3xl px-4 py-3 flex items-center gap-3">
        <Skeleton className="h-8 w-8" />
        <Skeleton className="h-6 w-48" />
      </div>
    </div>
    <div className="flex-1">
      <MessagesSkeleton />
    </div>
  </div>
);
